import { useIntegrationsRouteFilters } from '../../useIntegrationsRouteFilters';
import { IntegrationsTableView } from './IntegrationsTableView';

export function IntegrationsTable() {
  const filters = useIntegrationsRouteFilters();
  return <IntegrationsTableView controller={filters} />;
}
